// Formato de moneda para montos en pesos mexicanos: separador de miles con
// coma y dos decimales con punto (ej. $1,234.56), vía Intl (es-MX).
export function formatMXN (value) {
  const amount = Number(value) || 0
  return amount.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}



// WEBPACK FOOTER //
// ./src/commons/currency.js